'use client';

import Link from 'next/link';
import { Box, Button, Stack, Typography } from '@/primitives';
import { APP_ROUTE_PATHS, PUBLIC_ROUTES } from '@/configs/routes';
import { useAdminGuard } from '@/hooks/useAdminGuard';
import { blue, slate } from '@/lib/colours';
import { FadeInWhenVisible } from './FadeInWhenVisible';
import { landingClosingCta } from './homeLandingContent';
import { sectionShell } from './homeLandingSectionSx';

export function LandingClosingCta() {
  const { handleClickLink } = useAdminGuard(APP_ROUTE_PATHS.DASHBOARD);

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 10 },
        background: `linear-gradient(135deg, ${blue[900]} 0%, ${slate[900]} 55%, ${blue[950]} 100%)`,
      }}
    >
      <Box sx={{ ...sectionShell, position: 'relative', zIndex: 1 }}>
        <FadeInWhenVisible>
          <Stack
            alignItems="center"
            spacing={3}
            sx={{
              textAlign: 'center',
              py: { xs: 4, md: 6 },
              px: { xs: 2, md: 4 },
              borderRadius: '20px',
              border: `1px solid ${blue[700]}66`,
              background: `linear-gradient(180deg, ${blue[800]}22 0%, transparent 100%)`,
            }}
          >
            <Typography
              color={slate[50]}
              component="h2"
              sx={{ maxWidth: 520, textAlign: 'center' }}
              variant="headlinelarge"
            >
              {landingClosingCta.title}
            </Typography>
            <Typography
              color={slate[300]}
              sx={{ maxWidth: 480, textAlign: 'center' }}
              variant="bodylarge"
            >
              {landingClosingCta.subtitle}
            </Typography>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              sx={{ pt: 1 }}
            >
              <Button
                component={Link}
                href={PUBLIC_ROUTES.SEARCH}
                size="large"
                sx={{
                  px: 3,
                  py: 1.25,
                  borderRadius: '10px',
                  textTransform: 'none',
                  fontWeight: 600,
                  backgroundColor: blue[500],
                  '&:hover': { backgroundColor: blue[400] },
                }}
                variant="contained"
              >
                {landingClosingCta.searchLabel}
              </Button>
              <Button
                component={Link}
                href={PUBLIC_ROUTES.REGISTRY_LANDING}
                size="large"
                sx={{
                  px: 3,
                  py: 1.25,
                  borderRadius: '10px',
                  textTransform: 'none',
                  fontWeight: 600,
                  borderColor: slate[500],
                  color: slate[100],
                  '&:hover': {
                    borderColor: slate[300],
                    backgroundColor: slate[800],
                  },
                }}
                variant="outlined"
                onClick={handleClickLink}
              >
                {landingClosingCta.registryLabel}
              </Button>
            </Stack>
          </Stack>
        </FadeInWhenVisible>
      </Box>
    </Box>
  );
}
